/* JAYKEI contact hero: heading reveal + badge bounce on entry, and a gentle
   parallax on the photo and badge as the page scrolls. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function intro(root) {
    if (root.dataset.intro === 'ready') return;
    if (reduced) return;                 // CSS leaves everything in its resting state
    root.dataset.intro = 'ready';
    // two frames, so the starting transforms are committed before they animate
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('is-in'); });
    });
  }

  function parallax(root) {
    var layers = [].slice.call(root.querySelectorAll('[data-jk-par]'));
    if (!layers.length || reduced) return;

    var ticking = false;
    function apply() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      // only while the section is anywhere near the viewport
      if (rect.bottom < -200 || rect.top > window.innerHeight + 200) return;
      // 0 when the section's top is at the viewport top, growing as it leaves
      var scrolled = Math.max(0, -rect.top);
      layers.forEach(function (el) {
        var rate = parseFloat(el.dataset.jkPar) || 0;
        el.style.setProperty('--jk-py', (scrolled * rate).toFixed(2) + 'px');
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(apply);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  }

  function init() {
    [].forEach.call(document.querySelectorAll('[data-jk-contact]'), function (root) {
      intro(root);
      parallax(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
